export default "__VITE_ASSET__bc09e999__"